import { Injectable } from '@angular/core';
import {
    Folder,
    FolderUpdate,
    FolderWithAccessDetails
} from '../core-data-model/Folder.model';
import {
    FolderServer,
    UserServer
} from '../core-data-model/FoldersApi.serverinterface';
import { User } from '../core-data-model/User.model';
import { UserFactory } from '../object-factory/User.factory';

@Injectable({ providedIn: 'root' })
export class FolderTransformers {
    constructor(private userFactory: UserFactory) {}

    // Input the root(s) to the Transform function
    transformAll(foldersJSON: FolderServer[]): Folder[] {
        const folders: Folder[] = [];
        if (foldersJSON) {
            folders.push(...foldersJSON.map((item) => this.transform(item)));
            foldersJSON.forEach((folder) => {
                const childrenFolders = this.transformAll(folder.children);
                if (childrenFolders.length !== 0) {
                    folders.push(...childrenFolders);
                }
            });
        }
        return folders;
    }

    transform(item: FolderServer): Folder {
        return new Folder({
            name: item.folderName,
            id: item.folderId,
            folderPath: item.folderPath,
            childrenIds: item.children
                ? item.children.map((child) => child.folderId)
                : [],
            // If there's a parent. '0000...' comes from back-ends label for the root's null parent
            parentId:
                item.parentFolderId === '00000000-0000-0000-0000-000000000000'
                    ? null
                    : item.parentFolderId
        });
    }

    transformWithDetails(item: FolderServer): FolderWithAccessDetails {
        return new FolderWithAccessDetails({
            name: item.folderName,
            id: item.folderId,
            folderPath: item.folderPath,
            childrenIds: item.children
                ? item.children.map((child) => child.folderId)
                : [],
            // If there's a parent. '0000...' comes from back-ends label for the root's null parent
            parentId:
                item.parentFolderId === '00000000-0000-0000-0000-000000000000'
                    ? null
                    : item.parentFolderId,

            directAccessUsers: this.turnIntoUsers(item.directAccessUserDetails),
            inheritedAccessUsers: this.turnIntoUsers(
                item.inheritedAccessUserDetails
            )
        });
    }

    private turnIntoUsers(serverList: UserServer[]): User[] {
        return serverList
            ? serverList.map((userDetails) => {
                  const { userId, firstName, middleName, lastName } =
                      userDetails;

                  return this.userFactory.new_User({
                      firstName,
                      middleName,
                      lastName,
                      id: userId
                  });
              })
            : [];
    }

    transformToFolderServer(folder: FolderUpdate): {
        parentFolderId: string;
        folderName: string;
        directAccessUsers: string[];
    } {
        return {
            parentFolderId: folder.parentId,
            folderName: folder.name,
            directAccessUsers: folder.directAccessUsers
        };
    }
}
